module.exports = __webpack_public_path__ + "static/media/Poppins-BoldItalic.39e02f68.otf";